import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { ThemeMode } from "../theme/roleThemes";
import type { TransportAccent } from "../theme/transportThemes";

export type NavMode = "sidebar" | "topbar";
export type UiVariant = "standard" | "highVisibility";

type ThemeState = {
  mode: ThemeMode;
  navMode: NavMode;
  uiVariant: UiVariant;
  accent: TransportAccent;
  siderCollapsed: boolean;
  setMode: (mode: ThemeMode) => void;
  toggleMode: () => void;
  setNavMode: (navMode: NavMode) => void;
  toggleNavMode: () => void;
  setUiVariant: (v: UiVariant) => void;
  setAccent: (accent: TransportAccent) => void;
  setSiderCollapsed: (collapsed: boolean) => void;
  toggleSider: () => void;
};

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      mode: "light",
      navMode: "sidebar",
      uiVariant: "highVisibility",
      accent: "indigo",
      siderCollapsed: false,
      setMode: (mode) => set({ mode }),
      toggleMode: () => set({ mode: get().mode === "light" ? "dark" : "light" }),
      setNavMode: (navMode) => set({ navMode }),
      toggleNavMode: () => set({ navMode: get().navMode === "sidebar" ? "topbar" : "sidebar" }),
      setUiVariant: (uiVariant) => set({ uiVariant }),
      setAccent: (accent) => set({ accent }),
      setSiderCollapsed: (siderCollapsed) => set({ siderCollapsed }),
      toggleSider: () => set({ siderCollapsed: !get().siderCollapsed })
    }),
    {
      name: "healthcare-ui-theme-preferences"
    }
  )
);
